import { BillingTranslate } from './billingTranslate.model';

const billingTranslateEN: BillingTranslate = {
  quotaLimitModal: {
    title: 'Plan limit reached',
    description:
      "You've used {{current}} of {{limit}} {{resource}} included in your plan. Upgrade to keep creating.",
    usage: '{{current}} of {{limit}} {{resource}}',
    viewPlans: 'See plans',
    close: 'Close',
    closeAriaLabel: 'Close quota limit modal',
  },
  upgradePromptModal: {
    title: 'Premium feature',
    description:
      '{{feature}} is available on the Studio and Collective plans. Upgrade to unlock it.',
    knowPlans: 'See plans',
    close: 'Close',
    closeAriaLabel: 'Close upgrade modal',
  },
  statusBanner: {
    trialing_one: 'Your trial ends in 1 day. Subscribe to keep access.',
    trialing_other:
      'Your trial ends in {{daysLeft}} days. Subscribe to keep access.',
    pastDue: 'Your last charge failed. Update your card to avoid suspension.',
    suspended:
      'Your subscription is suspended. Settle the payment to regain access to your data.',
    nearLimit:
      "You've used {{current}} of {{limit}} active leads. Upgrade to unlock more.",
    cancelPending:
      'Your subscription ends on {{date}}. After that, you go back to the free Solo plan automatically.',
    cancelPendingCta: 'Undo',
    cta: {
      seePlans: 'See plans',
      updatePayment: 'Update payment',
    },
  },
  page: {
    title: 'Subscription',
    placeholderText:
      "Feature under construction. You'll be able to manage your plan here soon.",
    backCta: 'Back',
  },
  resources: {
    leads: 'leads',
    users: 'users',
    eventStatuses: 'columns',
  },
  features: {
    customEventStatuses: 'Custom columns on the event board',
    fullDashboard: 'Full dashboard',
    birthPhotographerMode: 'Birth photographer mode',
    csvExport: 'CSV export',
    pdfReports: 'PDF reports',
    prioritySupport: 'Priority support',
    nfse: 'NFS-e issuance',
  },
  planChoice: {
    title: 'Choose your plan',
    subtitle: 'Start for free or try Studio for 14 days, no charge.',
    cards: {
      solo: {
        name: 'Solo',
        price: 'Free',
        cta: 'Start for free',
        features: [
          'Up to 15 active leads',
          '1 user',
          'Event board with default columns',
          'Email support',
        ],
      },
      studio: {
        name: 'Studio',
        price: '$29.90/month',
        trialCta: 'Start 14-day trial',
        subscribeCta: 'Subscribe now',
        features: [
          'Unlimited leads',
          'Up to 5 users',
          'Custom columns on the board',
          'Full dashboard',
          'CSV export',
          'PDF reports',
        ],
      },
      collective: {
        name: 'Collective',
        price: '$79.90/month',
        cta: 'Subscribe to Collective',
        features: [
          'Everything in Studio',
          'Unlimited users',
          'Birth photographer mode',
          'NFS-e issuance',
          'Priority support',
        ],
      },
    },
    highlightedBadge: 'Most popular',
    coupon: {
      label: 'Have a coupon?',
      placeholder: 'EX: LAUNCH50',
      applyCta: 'Apply',
      removeCta: 'Remove',
      selectPlanFirst: 'No paid plan available to validate the coupon.',
      percentOff: '{{percent}}% off',
      freeMonths_one: '1 month free',
      freeMonths_other: '{{count}} months free',
      applied: 'Coupon {{code}} applied',
      invalidError: 'Invalid coupon. Please check the code.',
    },
  },
  billingPage: {
    title: 'Billing',
    activeCoupon: {
      title: 'Coupon {{code}} active',
      percentOff_one: '{{percent}}% off on the next invoice',
      percentOff_other: '{{percent}}% off on the next {{count}} invoices',
      freeMonths: 'Free months until {{date}}',
    },
    status: {
      title: 'Subscription status',
      nextChargeLabel: 'Next charge',
      priceLabel: 'Price',
      emptyValue: '—',
      perMonth: '/month',
      perYear: '/year',
      trialCountdown_one: 'Trial ends in 1 day',
      trialCountdown_other: 'Trial ends in {{count}} days',
      badge: {
        trialing: 'In trial',
        active: 'Active',
        pastDue: 'Past due',
        suspended: 'Suspended',
        canceled: 'Canceled',
      },
    },
    changePlan: {
      title: 'Change plan',
      subtitle: 'Upgrade to unlock more features or drop to a smaller plan.',
      cta: {
        current: 'Current plan',
        upgrade: 'Upgrade',
        downgrade: 'Downgrade',
      },
      features: {
        unlimitedLeads: 'Unlimited leads',
        maxLeads_one: 'Up to 1 active lead',
        maxLeads_other: 'Up to {{count}} active leads',
        maxUsers_one: '1 user',
        maxUsers_other: 'Up to {{count}} users',
      },
    },
    invoices: {
      title: 'Invoice history',
      emptyState: 'No invoices yet',
      loading: 'Loading invoices…',
      columns: {
        date: 'Date',
        amount: 'Amount',
        status: 'Status',
        invoice: 'Invoice',
        nf: 'Receipt',
        actions: 'Actions',
      },
      status: {
        paid: 'Paid',
        pending: 'Pending',
        overdue: 'Overdue',
        canceled: 'Canceled',
        refunded: 'Refunded',
      },
      pagination: {
        previous: 'Previous',
        next: 'Next',
        page: 'Page {{page}} of {{totalPages}}',
      },
      downloadInvoice: 'Download invoice',
      downloadNf: 'Download receipt',
    },
    paymentMethod: {
      title: 'Payment method',
      description: 'Manage your card on the Asaas dashboard.',
      updateCta: 'Update card',
    },
  },
  upgradeConfirmModal: {
    title: 'Confirm upgrade',
    creditFromCurrent: 'Credit from current plan',
    prorateNewPlan: 'Prorated amount for new plan',
    totalToCharge: 'Total to charge now',
    nextCycleAt: 'Next cycle charges on {{date}}.',
    confirmCta: 'Confirm upgrade',
    cancelCta: 'Cancel',
    loading: 'Loading preview…',
  },
  downgradeBlockedModal: {
    title: 'Your usage exceeds the new plan limits',
    leadExcess_one:
      'You have {{active}} active leads. The new plan allows up to {{limit}}. Deactivate {{reduceBy}} lead to downgrade now.',
    leadExcess_other:
      'You have {{active}} active leads. The new plan allows up to {{limit}}. Deactivate {{reduceBy}} leads to downgrade now.',
    userExcess_one:
      'You have {{active}} users. The new plan allows up to {{limit}}. Remove {{reduceBy}} user to downgrade now.',
    userExcess_other:
      'You have {{active}} users. The new plan allows up to {{limit}}. Remove {{reduceBy}} users to downgrade now.',
    deactivateLeadsCta: 'Manage leads',
    scheduleCta: 'Schedule for end of cycle',
  },
  couponInput: {
    label: 'Discount coupon',
    placeholder: 'EX: LAUNCH50',
    applyCta: 'Apply',
    confirmCta: 'Confirm coupon',
    redeemCta: 'Redeem',
    validating: 'Validating…',
    selectPlanFirst: 'Select a plan first.',
    appliedSuccess: 'Coupon applied.',
    validateError: 'Could not validate coupon.',
    conflictError:
      'This coupon has already been used or is no longer available.',
    percentOff: '{{percent}}% off',
    freeMonths_one: '1 month free',
    freeMonths_other: '{{count}} months free',
    invoicesScope_one: ' for 1 invoice',
    invoicesScope_other: ' for {{count}} invoices',
    totalWithDiscount: 'Total with discount:',
    redeemedFreeMonths_one: '1 free month applied — next charge on {{date}}',
    redeemedFreeMonths_other:
      '{{count}} free months applied — next charge on {{date}}',
    redeemedPercentOff_one: '{{percent}}% off on the next invoice',
    redeemedPercentOff_other: '{{percent}}% off on the next {{count}} invoices',
  },
  collectDocumentModal: {
    title: 'Confirm your CPF or CNPJ',
    subtitle:
      'We need your document to issue the charge. It is securely stored and only used for tax purposes.',
    documentTypeLabel: 'Document type',
    documentNumberLabel: 'Document number',
    cpfOption: 'CPF (individual)',
    cnpjOption: 'CNPJ (company)',
    typeRequired: 'Please select the document type.',
    invalidDocument: 'Invalid document. Please check the digits.',
    saveCta: 'Save and continue',
    cancelCta: 'Cancel',
    toasts: {
      saveSuccess: 'Document saved successfully.',
      saveError: 'Could not save the document. Please try again.',
    },
  },
  cancelButton: {
    label: 'Cancel subscription',
  },
  cancelModal: {
    title: 'Cancel subscription',
    commentLabel: 'Want to share more? (optional)',
    commentPlaceholder: 'Tell us what drove your decision…',
    commentRequired: 'Please share a bit more so we can understand.',
    continueCta: 'Continue',
    backCta: 'Back',
    cancelCta: 'Cancel',
    confirmCta: 'Confirm cancellation',
    reasons: {
      price: "It's too expensive",
      notUsing: "I'm not using it",
      switched: 'I switched to another tool',
      other: 'Other reason',
    },
    step2: {
      message:
        'Your subscription will stay active until {{date}}. After that, you go back to the free Solo plan automatically.',
    },
  },
  errors: {
    unauthorized: "You don't have permission to access this page.",
    loadSubscriptionFailed:
      "Couldn't load your subscription data. Please try again shortly.",
    retry: 'Try again',
  },
  toasts: {
    startFreePlanError: "Couldn't activate the free plan. Please try again.",
    startTrialError: "Couldn't start the trial. Please try again.",
    createCheckoutError:
      "Couldn't open the checkout. Please try again shortly.",
    subscriptionAlreadyExists:
      'This studio already has an active subscription. Manage your plan here.',
    checkoutSuccess: 'Payment processed! Your subscription is active.',
    updatePaymentMethodError:
      "Couldn't open the card manager. Please try again.",
    upgradeSuccess: 'Plan updated! Prorated charge already processed.',
    upgradeError: "Couldn't complete the upgrade. Please try again.",
    downgradeSuccess: 'Plan changed. New limits are now active.',
    downgradeScheduled:
      'Downgrade scheduled for the end of the cycle. You stay on the current plan until then.',
    downgradeError: "Couldn't complete the downgrade. Please try again.",
    cancelScheduled:
      'Cancellation scheduled for the end of the cycle. You can undo it any time until then.',
    cancelError: "Couldn't cancel the subscription. Please try again.",
    reactivateSuccess:
      'Your subscription has been reactivated. You keep full access.',
    reactivateError: "Couldn't reactivate the subscription. Please try again.",
    planNotAvailable: 'Plan currently unavailable.',
    loadPlansError: "Couldn't load the paid plans. Please try again shortly.",
  },
};

export default billingTranslateEN;
